import React, { useState, useEffect } from "react";
import { Box, Image, Text, VStack } from "@chakra-ui/react";

const LoginLeftPanelGradient = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Curated high-quality Unsplash images for HR/workplace theme
  const images = [
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1400&q=90&fit=crop&crop=faces,entropy", // Diverse team meeting
    "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?w=1400&q=90&fit=crop&crop=center", // Modern workspace collaboration
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1400&q=90&fit=crop&crop=faces", // Professional business team
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1400&q=90&fit=crop&crop=center", // Creative office collaboration
    "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=1400&q=90&fit=crop&crop=faces", // Diverse professional team
    "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=1400&q=90&fit=crop&crop=faces,center", // HR meeting discussion
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Box
      display={{ base: "none", md: "block" }}
      width="50%"
      position="relative"
      overflow="hidden"
      bg="#1a1a2e"
    >
      {/* Image Carousel */}
      {images.map((imageUrl, index) => (
        <Box
          key={index}
          position="absolute"
          inset="0"
          backgroundImage={`url(${imageUrl})`}
          backgroundSize="cover"
          backgroundPosition="center"
          opacity={currentImageIndex === index ? 1 : 0}
          transition="opacity 1.5s ease-in-out"
          zIndex={0}
        />
      ))}

      {/* Dark Gradient Overlay */}
      <Box
        position="absolute"
        inset="0"
        bgGradient="linear(to-b, rgba(26, 26, 46, 0.75) 0%, rgba(26, 26, 46, 0.90) 100%)"
        zIndex={1}
      />

      {/* Subtle Pattern Overlay */}
      <Box
        position="absolute"
        inset="0"
        opacity="0.03"
        backgroundImage="radial-gradient(circle, rgba(255,255,255,0.2) 1px, transparent 1px)"
        backgroundSize="30px 30px"
        zIndex={1}
      />

      {/* Content Container */}
      <Box
        position="absolute"
        inset="0"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={10}
        zIndex={2}
      >
        <VStack spacing={6} align="center">
          {/* Minimal Logo */}
          <Box
            bg="rgba(255, 255, 255, 0.08)"
            borderRadius="lg"
            p={3}
            backdropFilter="blur(8px)"
            border="1px solid"
            borderColor="rgba(255, 255, 255, 0.1)"
          >
            <Image
              src="/image.png"
              alt="NoraHuman"
              boxSize={{ md: "70px", lg: "80px" }}
              objectFit="contain"
              opacity="0.95"
            />
          </Box>

          {/* Minimal Typography */}
          <VStack spacing={2} align="center">
            <Text
              color="rgba(255, 255, 255, 0.9)"
              fontFamily="var(--font-sans)"
              fontSize={{ md: "xl", lg: "2xl" }}
              fontWeight="500"
              letterSpacing="0.02em"
            >
              NoraHuman
            </Text>

            <Text
              color="rgba(255, 255, 255, 0.5)"
              fontFamily="var(--font-sans)"
              fontSize={{ md: "xs", lg: "sm" }}
              fontWeight="400"
              letterSpacing="0.05em"
              textAlign="center"
            >
              HR Platform
            </Text>
          </VStack>

          {/* Image Navigation Dots */}
          <Box display="flex" gap={2} mt={4}>
            {images.map((_, index) => (
              <Box
                key={index}
                width={currentImageIndex === index ? "20px" : "6px"}
                height="6px"
                borderRadius="full"
                bg={
                  currentImageIndex === index
                    ? "rgba(255, 255, 255, 0.7)"
                    : "rgba(255, 255, 255, 0.25)"
                }
                cursor="pointer"
                transition="all 0.3s ease"
                onClick={() => setCurrentImageIndex(index)}
                _hover={{
                  bg:
                    currentImageIndex === index
                      ? "rgba(255, 255, 255, 0.85)"
                      : "rgba(255, 255, 255, 0.4)",
                }}
              />
            ))}
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default LoginLeftPanelGradient;
